import { render, staticRenderFns } from "./detailDefForm.vue?vue&type=template&id=1a4a3f50&scoped=true"
import script from "./detailDefForm.vue?vue&type=script&lang=js"
export * from "./detailDefForm.vue?vue&type=script&lang=js"
import style0 from "./detailDefForm.vue?vue&type=style&index=0&id=1a4a3f50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4a3f50",
  null
  
)

export default component.exports